import { InputBase } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { Field, FieldProps } from 'formik';
import React from 'react'
import { IAddress } from '../../reducers/bookings/types';
import { AddressPickerInput } from './AddressPickerInput';
import { TextField } from 'formik-material-ui';
import { useTranslation } from 'react-i18next';

interface IProps {
  fieldName: string;
  required?: boolean;
  addGeometry?: boolean;
  onChange(address?: IAddress): void;
  disabled?: boolean;
  label?: string;
  hideInternalLabel?: boolean;
}

const AddressPicker = (props: IProps) => {
  const { t } = useTranslation();
  return (
    <Field
      component={TextField}
      name={props.fieldName}
      required={props.required || false}
      disabled={props.disabled || false}
    >
      {({ field, form: { setTouched, touched }, meta }: FieldProps) => {
        return (
          <AddressPickerInput
            address={field.value}
            placeholder={`${t("root:typeAddress")}`}
            required={props.required || false}
            setAddress={(address?: IAddress) => {
              setTouched({ ...touched, [props.fieldName]: true });
              const fieldValue = address ? address : field.value;
              props.onChange(fieldValue)
            }}
            validationError={meta.error}
            touched={meta.touched}
            addGeometry={props.addGeometry}
            label={props.label}
            hideInternalLabel={props.hideInternalLabel}
          />
        )
      }}
    </Field>
  )
}
export default AddressPicker